import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initArticleRecipe from '../sections/article-recipe';

ready(() => {
  initArticleRecipe();
});

onShopifySectionLoad(() => {
  initArticleRecipe();
});
